import React, { useState } from "react";
import {
  WalletIcon,
  TagIcon,
  UsersIcon,
  TableCellsIcon,
  CheckIcon,
} from "@heroicons/react/24/outline";
import { useLocation, useParams } from "react-router-dom";
import {
  useDayStatsQuery,
  useOrderListQuery,
} from "../../app/apiSlices/dbSlice";
import { IOrder, monthNames } from "../DB/Orders";
import OrderModalInfo from "../Modals/OrderModalInfo";
import Pagination from "../Pagination";
import DBReportModal from "../Modals/DBReportModal";

const Distributor = () => {
  const [show, setShow] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  const [currentOrder, setCurrentOrder] = useState<IOrder | null>(null);
  const [currentPage, setCurrentPage] = useState(1);

  const { id } = useParams();
  const { state } = useLocation();
  const { db } = state;
  const { data, isLoading } = useOrderListQuery({ id, page: currentPage }, {
    refetchOnMountOrArgChange: true
  });
  const { data: dayStats } = useDayStatsQuery({ id });


  const bringUpModal = (order: IOrder) => {
    setCurrentOrder(order);
    setShow(true);
  };

  if(!data) return (
    <div className="flex items-center justify-center py-10 w-full mx-auto">
      <svg
        aria-hidden="true"
        className=" w-8 h-8 text-gray-200 animate-spin  fill-white"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="currentColor"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill"
        />
      </svg>
    </div>
  );

  const { pages } = data.data;


  return (
    <section className="w-full max-w-7xl mx-auto pb-6">
      <DBReportModal show={showDownload} setShow={setShowDownload} id={id} name={db.name} />
      <OrderModalInfo show={show} setShow={setShow} order={currentOrder} />
      <div className="flex flex-row flex-wrap items-center justify-between w-full px-4 py-10 mx-auto gap-4 text-center">
        <Card
          value={dayStats?.data.monthTotalSales || 0}
          title="Total Sales"
          Icon={WalletIcon}
        />
        <Card
          value={
            parseInt(dayStats?.data.unpaidOrders) +
              parseInt(dayStats?.data.paidOrders) || 0
          }
          title="Total Orders"
          Icon={TableCellsIcon}
        />
        <Card value={db.asr_count} title="No. of ASRs" Icon={UsersIcon} />
        <Card
          value={db.retailers_count}
          title="No. of Retailers"
          Icon={UsersIcon}
        />
        <Card
          value={dayStats?.data.completedOrders || 0}
          title="Completed Orders"
          color2
          Icon={CheckIcon}
        />
        <Card
          value={dayStats?.data.unpaidOrders || 0}
          title="Unpaid"
          color1
          Icon={TagIcon}
        />
      </div>

      {/* CLICKER */}
      
      <div className="my-8 mx-8">
        <button
          onClick={() => setShowDownload(true)}
          className="px-4 py-3 w-fit inline-flex items-center justify-center border border-transparent text-base font-medium rounded-xl text-white bg-[#2E4057]">
          Download Report
        </button>
      </div>



      {pages > 1 && !isLoading && (
        <Pagination
          nPages={pages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}
      <table className="overflow-x-auto w-full">
        <thead className="bg-white border-b border-gray-200">
          <tr className="text-[#2E4057] font-light">
            <th className="p-4 text-sm font-medium text-left">Order ID</th>
            <th className="p-4 text-sm font-medium text-left">Time</th>
            <th className="p-4 text-sm font-medium text-left">Client</th>
            <th className="p-4 text-sm font-medium text-left">Status</th>
            <th className="p-4 text-sm font-medium text-left">Payment</th>
            <th className="p-4 text-sm font-medium text-left">Value</th>
            <th className="p-4 text-sm font-medium text-left">Link</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {data?.data?.orders.map(
            (item: IOrder, index: React.Key | null | undefined) => (
              <tr className="" key={index}>
                <td className="px-4 py-4 text-sm text-slate-400">
                  {item.order_number}
                </td>
                <td className="px-4 py-4 text-sm text-slate-400">
                  {item.created_at.split("T")[0]}
                </td>
                <td className="px-4 py-4 text-sm text-slate-400">
                  {item.asr.name}
                </td>
                <td className={`px-4 py-4 text-sm text-slate-400`}>
                  <p
                    className={`
                ${
                  item.status === "Completed"
                    ? "text-[#2CC56F] bg-green-200 px-4 py-2 w-fit rounded-full"
                    : item.status === "Pending"
                    ? "text-[#F2994A] bg-yellow-100 px-4 py-2 w-fit rounded-full"
                    : item.status === "Canceled"
                    ? "text-red-500 bg-red-200 px-4 py-2 w-fit rounded-full"
                    : ""
                }
                `}
                  >
                    {item.status}
                  </p>
                </td>
                <td className="px-4 py-4 text-sm text-slate-400">
                  <p
                    className={`
                ${
                  item.payment_status === "Paid"
                    ? "text-[#2CC56F]"
                    : item.payment_status === "Unpaid"
                    ? "text-red-500"
                    : ""
                }
                  `}
                  >
                    {item.payment_status}
                  </p>
                </td>
                <td className="px-4 py-4 text-sm text-slate-400">
                  {item.grand_total}
                </td>
                <td className="px-4 py-4 text-sm text-slate-400">
                  <div
                    className="bg-[#2E4057] px-6 py-2 text-[#FFFFFF] rounded-full w-fit cursor-pointer"
                    onClick={() => bringUpModal(item)}
                  >
                    View Order
                  </div>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>

      {isLoading && (
        <div className="flex items-center justify-center py-10 w-full mx-auto">
          <svg
            aria-hidden="true"
            className=" w-8 h-8 text-gray-200 animate-spin  fill-white"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
      )}
      {!data?.data?.orders.length && !isLoading && (
        <div className="flex items-center justify-center py-10 w-full mx-auto bg-white">
          <p className="text-gray-400 text-lg">No Orders yet</p>
        </div>
      )}
    </section>
  );
};

export default Distributor;

interface CardProps {
  title?: string;
  description?: string;
  Icon?: any;
  value?: string | number;
  color1?: boolean;
  color2?: boolean;
}

const Card = ({
  title,
  description,
  Icon,
  value,
  color1,
  color2,
}: CardProps) => (
  <div className="p-4 w-[200px] h-[200px] lg:w-[180px] lg:h-[180px] flex flex-col items-center bg-white">
    <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-md bg-[#2E4057]">
      {/* Render icon if any, else render wallet Icon */}
      {Icon ? (
        <Icon className="w-5 h-5 text-white" />
      ) : (
        <WalletIcon className="w-6 h-6 text-white" />
      )}
    </div>
    <h3 className="text-sm font-medium text-gray-900">{title}</h3>
    <h3 className="text-xs font-normal text-gray-500">
      {monthNames[new Date().getMonth()]} {new Date().getUTCDate()}
    </h3>
    <p
      className={`mt-6 text-sm font-medium ${
        color1 ? `text-[#F2994A]` : color2 ? `text-[#219653]` : `text-gray-900`
      }`}
    >
      {value}
    </p>
  </div>
);
